import apiClient from "./apiClient";

const courseServices = {
  getCourseDetails: (id) => {
    return apiClient.get(`/courses/${id}`);
  },
  getCourseResources: (id) => {
    return apiClient.get(`/course-resources/${id}`);
  },
  getCourseLessons: (id) => {
    return apiClient.get(`/course-lessons/${id}`);
  },
  getSkillsCount: (id) => {
    return apiClient.get(`/course-skills/${id}`);
  },
  getCodeSolution: (lessonId) => {
    return apiClient.get(`/code-solution/${lessonId}`);
  },
  getSmoothyImageLibrary: () => {
    return apiClient.get(`/image-categories`);
  },
  getSmoothyImageByID: (
    id,
    { page = 1, per_page = 9999, sort_by = "name", sort_dir = "asc", search = "" } = {}
  ) => {
    let url = `/image-libraries/${id}`;
    const params = new URLSearchParams({ page, per_page, sort_dir, sort_by });

    if (search) {
      params.append("search", search);
    }

    return apiClient.get(`${url}?${params.toString()}`);
  },

  getSmoothySoundLibrary: () => {
    return apiClient.get(`/sound-categories`);
  },
  getSmoothySoundByID: (
    id,
    { page = 1, per_page = 9999, sort_by = "name", sort_dir = "asc", search = "" } = {}
  ) => {
    let url = `/sound-libraries/${id}`;
    const params = new URLSearchParams({ page, per_page, sort_dir, sort_by });

    if (search) {
      params.append("search", search);
    }

    return apiClient.get(`${url}?${params.toString()}`);
  },
};

export default courseServices;
